<template>
  <div v-if="showTopBanner" class="top-banner">
    <button
      type="button"
      class="top-banner__close"
      @click="isTopBannerClosed = true"
      aria-label="Закрыть баннер"
    >
      <img src="@/assets/images/icons/close.svg" class="close" alt="Close" />
    </button>
    <div class="container top-banner__inner">
      <div class="top-banner__content">
        <span class="top-banner__text"
          >Купите подписку для полной свободы к ресурсу, доступ к возможностям и
          в B2B-Маркетплейс, вы сможете создавать свои товары и услуги для
          получения новых клиентов, вас будут видеть в ленте
          B2B-Маркетплейс</span
        >
        <button type="button" class="top-banner__button" @click="buyPremium">
          Подключить Premium
        </button>
      </div>
    </div>
  </div>

  <header class="header main">
    <div class="d-flex container justify-content-between align-items-center">
      <router-link to="/" class="logo">
        <img src="@/assets/images/logo.svg" alt="X Global Logo" />
      </router-link>
      <Burger />
      <nav class="navigation">
        <ul>
          <li><router-link to="/">Главная</router-link></li>
          <li>
            <router-link to="/counter-parties">Проверить компанию</router-link>
          </li>
          <li>
            <router-link to="/sellers">Для продавцов</router-link>
          </li>
          <li><router-link to="/marketplace">Маркетплейс</router-link></li>
          <li v-if="isLoggedIn">
            <router-link to="/tariffs">Тарифы</router-link>
          </li>
          <li>
            <router-link to="/about">О компании</router-link>
          </li>
          <li><router-link to="/blog">Блог</router-link></li>
        </ul>
      </nav>
      <div class="header-actions">
        <Translator />
        <div class="login d-flex">
          <router-link v-if="!isLoggedIn || !currentUser" to="/login"
            >Войти</router-link
          >
          <template v-else>
            <router-link to="/profile/info" class="username">{{
              displayName
            }}</router-link>
          </template>
        </div>
      </div>
    </div>
  </header>
  <AuthModal />
  <NewPasswordModal ref="newPasswordModalRef" />
</template>

<script>
import { defineComponent, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Burger from "./Burger.vue";
import AuthModal from "../components/Modals/AuthModal.vue";
import NewPasswordModal from "../components/Modals/NewPasswordModal.vue";
import { useRouter, useRoute } from "vue-router";
import Translator from "./Translator.vue";

export default defineComponent({
  components: { Burger, AuthModal, NewPasswordModal, Translator },
  name: "Header",
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
    const currentUser = computed(() => store.state.user.user);
    const router = useRouter();
    const route = useRoute();

    const newPasswordModalRef = ref(null);
    const isTopBannerClosed = ref(false);

    const displayName = computed(() => {
      const fullName = currentUser.value?.full_name?.trim() || "";
      const parts = fullName.split(/\s+/).filter(Boolean);

      if (parts.length >= 2) {
        return parts[1];
      }

      return fullName;
    });

    const showTopBanner = computed(() => {
      if (isTopBannerClosed.value) return false;
      if (!isLoggedIn.value) return true;

      const membership = currentUser.value?.name_membership;
      return !membership || membership !== "Premium";
    });

    const buyPremium = () => {
      if (isLoggedIn.value) {
        router.push({ name: "Tariffs" });
      } else {
        router.push("/login");
      }
    };

    const openPasswordModal = () => {
      newPasswordModalRef.value.openModal();
    };

    onMounted(() => {
      if (newPasswordModalRef.value && route.query.uid) {
        openPasswordModal();
      }
    });

    return {
      currentUser,
      isLoggedIn,
      router,
      newPasswordModalRef,
      buyPremium,
      openPasswordModal,
      displayName,
      showTopBanner,
      isTopBannerClosed,
    };
  },
});
</script>

<style lang="scss">
@import "@/assets/styles/Header.scss";
@import "@/assets/styles/media.scss";
</style>
